import { SERVICE_FIELD_KEYS } from '~/components/AiSearchChips/ServicesChips/serviceGrammar';
import { ALLOWED_BILLED_UPON, ALLOWED_DISCOUNT_TYPE, ALLOWED_PRICING_TYPE, ALLOWED_RECURRENCE, ALLOWED_START_ON_TYPE } from '~/types/api/drafts-search';
const DRAFTS_SERVICE_FIELDS = new Set(SERVICE_FIELD_KEYS.filter((field)=>field !== 'automaticState' && field !== 'completionState'));
export const DRAFTS_SERVICE_FIELD_GRAMMAR = {
    allowed: {
        billedUpon: ALLOWED_BILLED_UPON,
        recurrence: ALLOWED_RECURRENCE,
        pricingType: ALLOWED_PRICING_TYPE,
        discountType: ALLOWED_DISCOUNT_TYPE,
        startOnType: ALLOWED_START_ON_TYPE
    },
    fields: DRAFTS_SERVICE_FIELDS,
    seedableFields: new Set()
};
